export default __webpack_public_path__ + "static/media/Undercurrent_20BTN.69150ee0.eot";